import { useBillingCurrentPricePlanViewModelQuery } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';

import { CurrentPricePlanBillingData, isCurrentPricePlanBillingDataValid } from '../model/currentPricePlanBillingData';

const useCurrentPricePlanBillingData = (companyId: string): CurrentPricePlanBillingData | null => {
  const { data, loading, error } = useBillingCurrentPricePlanViewModelQuery({
    fetchPolicy: FetchPolicyKeys.CACHE_AND_NETWORK,
    variables: { companyId },
  });

  if (loading || error || !isCurrentPricePlanBillingDataValid(data)) return null;

  return data;
};

export default useCurrentPricePlanBillingData;
